import Alien from './alien';

export default class Fireling extends Alien {
    constructor(x, y) {
        super(x, y, "effects", "fire_01.png");
        this.anchor.set(0.5, 1);
        this.shadow.alpha = 0;
        this.scale.set(0.5);
        this.animations.add('idle', ["fire_01.png"]);
        this.animations.add('move', Phaser.Animation.generateFrameNames('fire_', 1, 5, '.png', 2), 16, true).play();
        this.animations.add('attack', Phaser.Animation.generateFrameNames('fire_', 1, 5, '.png', 2), 20, true).play();
        this.animations.add('die', Phaser.Animation.generateFrameNames('smoke_', 1, 6, '.png', 2), 16, false);
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 1; }

    onHit() {
        this.state = 'destroyed';
        this.animations.play('die').onComplete.add(() => {
            this.destroy();
        })
    }

    onCollideWithObject(object) {
        if (!object.constructor.type === "fire") return;
        super.onCollideWithObject(object);
    }

    static get type() { return 'fireling' }
    static get label() { return 'Fire' }
    static get description() {
        return game.rnd.pick([
            `OH MY GOD IT BURNS!`,
            `Ouch!`,
            `I guess I don't need eyebrows anymore. Or fingers.`,
            `My fingers are melting!`,
            `hot hOT HOT HOT!`,
            `*sizzling*`,
        ])
    }

    get movingSpeed() {
        return 60;
    }

    get eatSound() {
        return 'flame-4';
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/fireling.js